export const CampaignState = {
  DRAFT: "DRAFT",
  REVIEW: "REVIEW",
  CONFIRMED: "CONFIRMED",
  SCHEDULED: "SCHEDULED",
  LIVE: "LIVE",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  STOPPED: "STOPPED",
};

export const CampaignStateText = {
  DRAFT: "Draft",
  REVIEW: "Waiting for confirmation",
  CONFIRMED: "Confirmed",
  SCHEDULED: "Scheduled",
  LIVE: "Live",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  STOPPED: "Stopped",
};
